import { http } from "../../../config/HttpMethod";
import { anchorIDPayload, ChargePumpData, GasCalculationData, GasEffChangePayload, GasHandlerEquipmentsPayload, GasSeparatorEquipmentsPayload, GasSepEfficiencyPayload, GasSeperatorData, GetChargePumpListPayload, GKXListPayload, powerRatingPayload, PumpCapacityCurveGraphData, separatorListPayload, SpecialPumpCalculationOutputPayload, TFVWarningPayload } from "../../../store/model/calculations/calculation";
import { ESP_ENDPOINTS } from "../endpoints";

export const getSeparatorList = async (payload: separatorListPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SEPS_LIST}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getPowerRating = async (payload: powerRatingPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_POWER_RATING}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasCalTubingOD = async (payload: string | number | null) => {
    const params = {
        AcnhorOD: payload,
    };
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_ANCHOR_TUBING_OD}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasCalAnchorID = async (payload: anchorIDPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_ANCHOR_ID}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getTFVWarning = async (payload: TFVWarningPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_TFV_WARNING}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasDataOnDesignChange = async (payload: any) => {
    try {
        const response = await http.post<{ intake_OP: GasCalculationData, anchor_OP: GasCalculationData }>(`${ESP_ENDPOINTS?.GET_GAS_DESIGN_CHANGE}`, payload);
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getChargePumpList = async (payload: GetChargePumpListPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_CHARGE_PUMP_LIST}`, {
            params,
        });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasSeparatorEquipments = async (payload: GasSeparatorEquipmentsPayload ) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_GAS_SEPARATORS}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasHandlerEquipments = async (payload: GasHandlerEquipmentsPayload ) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_GAS_HANDLERS}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasSepEfficiency = async (payload: GasSepEfficiencyPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_GAS_SEP_EFFICIENCY}`, { params });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGasEffChangeData = async (payload: GasEffChangePayload) => {
    try {
        const response = await http.post<GasSeperatorData>(`${ESP_ENDPOINTS?.GET_GAS_EFF_CHANGE}`, payload);
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGKXListData = async (payload: GKXListPayload) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_GKX_LIST}`, {
            params,
        });
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getSpecialPumpsCalculations = async (
    payload: SpecialPumpCalculationOutputPayload
) => {
    try {
        const response = await http.post(
            `${ESP_ENDPOINTS?.GET_SPECIAL_PUMP_CALCULATIONS}`,
            payload
        );
        return response?.data;
    } catch (err) {
        console.error(err);
    }
};

export const getGKXCapacityGraphData = async (params: any) => {
    try {
        const response = await http.get(
            `${ESP_ENDPOINTS?.GET_GKX_GRAPH_DATA}`,
            { params }
        );

        const data = response?.data || {};
        data.head = Array.isArray(data.head) ? data.head : [];
        data.bhp = Array.isArray(data.bhp) ? data.bhp : [];
        data.efficiency = Array.isArray(data.efficiency) ? data.efficiency : [];

        return data;
    } catch (err) {
        console.error(err);
    }
};

export const GetGasChPmp1ChangeValues= async (postInputSepData: object) => {
    try {
        const response = await http.post<ChargePumpData>(`${ESP_ENDPOINTS?.GET_GAS_CHG_PUMP_CHANGE}`, postInputSepData);
        return response?.data;
    } catch (err) {
        console.log(err);
    }
};

export const GetEquipmentsForChargePumps = async (payload: any) => {
    const params = payload;
    try {
        const response = await http.get(`${ESP_ENDPOINTS?.GET_SR_PUMPS}`, { params });
        return response?.data;
    } catch (err) {
        console.log(err);
    }
}

export const GetCPCapacityGraphData = async (params: any) => {
    const response = await http.get(`${ESP_ENDPOINTS?.GET_CP_GRAPH_DATA}`, { params })
    const data = response?.data || {};
    data.head = Array.isArray(data.head) ? data.head : [];
    data.bhp = Array.isArray(data.bhp) ? data.bhp : [];
    data.efficiency = Array.isArray(data.efficiency) ? data.efficiency : [];

    return data;
}